import React from 'react';
import { Carousel } from 'zarm';
import './index.less';
export default function AdBanner(props) {
  const {
    attrs
  } = props;
  const {
    dataSource,
    isDefault
  } = attrs;

  if (!dataSource || !dataSource.length || isDefault === false) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "cc-ad-banner"
  }, /*#__PURE__*/React.createElement(Carousel, {
    loop: true,
    autoPlay: true
  }, dataSource.map((item, idx) => {
    return /*#__PURE__*/React.createElement("a", {
      href: item.link,
      key: +idx
    }, /*#__PURE__*/React.createElement("img", {
      src: item.img,
      alt: "",
      width: "100%"
    }));
  })));
}